// The JavaScript that handles the "Edit" button functionality can be found in
// ../input-fake/input-fake.js.
